import React from 'react';
import {
    ClusterNumberFieldEdit,
} from '@domain/dashboard/cluster/campaign-table-cluster-components/cluster-number-field-edit';
import { CLUSTER_FIELDS_FUNCTIONS } from '@domain/dashboard/cluster/cluster.constants';

interface EditBudgetProps {
    value: number
    row: any
}

export const MonthlyBudgetEdit = ({
    value,
    row,
}: EditBudgetProps) => (
    <ClusterNumberFieldEdit
        row={row}
        value={value}
        key={CLUSTER_FIELDS_FUNCTIONS.budget.field}
        field={CLUSTER_FIELDS_FUNCTIONS.budget.field}
    />
);
